// https://switcheroo.atlassian.com/ui/gates/339bb9dc-b17b-40aa-af80-9b37a4e98c58/key/rovo-ext_chat_input_rovo_extension_cta
export const ROVO_EXTENSION_CHAT_INPUT_CTA_EXPERIMENT = 'rovo-ext_chat_input_rovo_extension_cta';

export const ROVO_EXTENSION_CHAT_INPUT_MESSAGE_TEMPLATE_ID =
	'rovo-extension-install-cta-rovo-chat-input';

// https://switcheroo.atlassian.com/ui/gates/d6b8611c-3b34-4296-bf30-83ff802a8826/key/rovo-ext_chat_input_rovo_extension_cta-confluence
export const ROVO_EXTENSION_CHAT_INPUT_CTA_CONFLUENCE_EXPERIMENT =
	'rovo-ext_chat_input_rovo_extension_cta-confluence';

export const ROVO_CHAT_LONG_RUNNING_TASK_SPOTLIGHT_TEMPLATE_ID =
	'rovo-chat-long-running-task-spotlight';

export const ROVO_CHAT_3P_CONNECTOR_NUDGE_TEMPLATE_ID = 'rovo-chat-input-banner-3p-connector-nudge';

export const ROVO_MOBILE_DEEP_RESEARCH_CTA_TEMPLATE_ID =
	'rovo-mobile-deep-research-cta-rovo-chat-input';
